import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import Switch from "react-switch";
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { basePath } from '../Constants/constant';
import { AppContext } from '../ContextApi/ContextApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotateRight, faGear, faShieldHalved, faFileArrowUp, faCircleCheck, faFilePdf, faTrash } from '@fortawesome/free-solid-svg-icons'

function AccessControl(props) {
    const { getData ,apiHeaderJSON} = useContext(AppContext);

    // ====== NEW: tab state to switch between "Access Control" and "General Settings" ======
    // 'access' | 'general'
    const [activeTab, setActiveTab] = useState('access');

    const [allRoles, setAllRoles] = useState([]);
    const [allModules, setAllModules] = useState([]);
    const [allAccess, setAllAccess] = useState([]);
    const [filterAccess, setFilterAccess] = useState([]); 
    const [isAction, setIsAction] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [roleId, setRoleId] = useState(false);
    const [moduleId, setModuleId] = useState(false);
    const [edit_access, setEdit_access] = useState(false);
    const [accessModal, setAccessModal] = useState(false);
    const [accessData, setAccessData] = useState({
        id: "",
        list_access: false,
        view_access: false,
        add_access: false,
        edit_access: false,
        delete_access: false,
    })
    // get all roles
    const getRoleData = async () => {
        try {
            let response = await axios.get(`${basePath}/getroles`,{ 
                headers:apiHeaderJSON,
            });
            setRoleId(response?.data[0].id);
            setAllRoles(response?.data);
        } catch (error) {
            console.log(error);
        }
    }
    //get all modules
    const getModuleData = async () => {
        try {
            let response = await axios.get(`${basePath}/getmodules`);
            // console.log(response);
            setModuleId(response?.data[0].id);
            setAllModules(response?.data);
        } catch (error) {
            console.log(error);
        }
    }
    //get all access comtrol data
    const getPermissionData = async () => {
        try {
            setLoading(true);
            let response = await axios.get(`${basePath}/getpermissions`);
            // console.log(response?.data);
            setAllAccess(response?.data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }
    //filter all access control data
    const filterPermissionData = () => {
        // getPermissionData();
        let data = allAccess?.filter((val) => {
            return val?.role_id === roleId
        });
        let n = allModules?.length;
        const mod = [];
        while (n > 0) {
            const check = allAccess?.every((val) => {
                return val?.role_id === roleId && val?.module_id === allModules[n - 1].id;
            });
            // console.log(check, allModules[n - 1].id);
            if (!check) {
                mod.push(allModules[n - 1]?.module_name);
            }
            n--;
        }    
        setFilterAccess(data);
    }

    useEffect(() => {
        getRoleData();
        getModuleData();
        getPermissionData();
    }, []);
    useEffect(() => {
        if (roleId) {
            filterPermissionData();
        }
    }, [roleId, allAccess]);

    const submit = () => {
        let data = {
            role_id: roleId,
            module_id: moduleId,
            list_access: accessData?.list_access,
            view_access: accessData?.view_access,
            add_access: accessData?.add_access,
            edit_access: accessData?.edit_access,
            delete_access: accessData?.delete_access,
        }
        const options = {
            url: `${basePath}/permission`,
            method: "POST",
            headers: {
                ...apiHeaderJSON,
            },
            data: data,
        }
        if (roleId && moduleId) {
            axios(options)
                .then((response) => {
                    if (response.status == 200) {
                        setLoading(false);
                        setAccessModal(false);
                        setAccessData({
                            list_access: false,
                            view_access: false,
                            add_access: false,
                            edit_access: false,
                            delete_access: false,
                        });
                        getPermissionData();
                        toast.success("Access Control Added Successfully");
                        getData();
                    }
                    else {
                        setLoading(false);
                        toast.error("Unable to Add Access Control");
                    }
                })
                .catch(() => {
                    setLoading(false);
                    toast.error("Unable to update");
                });
        } else {
            if (!roleId && !moduleId) {
                toast.error("Role And Module Are Required");
            }
            else if (!roleId) {
                toast.error("Role Is Required");
            }
            else {
                toast.error("Module Is Required");
            }
        }
    }
    const handleSubmitUpdate = () => {

        let data = {
            role_id: roleId,
            module_id: moduleId,
            list_access: accessData?.list_access,
            view_access: accessData?.view_access,
            add_access: accessData?.add_access,
            edit_access: accessData?.edit_access,
            delete_access: accessData?.delete_access,
        }
        const options = {
            url: `${basePath}/updatepermission/${accessData?.id}`,
            method: "PUT",
            headers: {
                ...apiHeaderJSON,
            },
            data: data,
        }
        axios(options)
            .then((response) => {
                if (response?.status === 200) {
                    setAccessModal(false);
                    setAccessData({
                        list_access: false,
                        view_access: false,
                        add_access: false,
                        edit_access: false,
                        delete_access: false,
                    });
                    getPermissionData();
                    setLoadingUpdate(false);
                    toast.success("Access Control Updated Successfully");
                }
                else {
                    setLoadingUpdate(false);
                    toast.error("Unable to update Access Control");
                }
            })
            .catch(() => {
                setLoadingUpdate(false);
                toast.error("Unable to update Access Control");
            });
        setEdit_access(false);
    }
    const handleEdit = (e, idx, id, role_Id, module_Id) => {
        setEdit_access(id);
        setRoleId(role_Id);
        setModuleId(module_Id);
        setIsAction(false);
        setAccessData({
            id: id,
            view_access: filterAccess[idx]?.view_access,
            add_access: filterAccess[idx]?.add_access,
            edit_access: filterAccess[idx]?.edit_access,
            delete_access: filterAccess[idx]?.delete_access,
        });
    }
    const handleDelete = (e, id) => {
        if (id) {
            setLoading(true);
            const options = {
                url: `${basePath}/deletepermission/${id}`,
                method: "DELETE",
                headers: {
                    ...apiHeaderJSON,
                },
            }
            axios(options)
                .then((response) => {
                    if (response.status === 200) {
                        setLoading(false);
                        getPermissionData();
                        filterPermissionData();
                        getData();
                        toast.success("Access Control Deleted Successfully");
                    }
                    else {
                        setLoading(false);
                        toast.error("Unable to Delete");

                    }
                })
                .catch((e) => {
                    console.log(e);
                    setLoading(false);
                    toast.error("Unable to Delete");
                });
        }
        else {
            toast.error("Unable to delete");
        }

    }

    // ====================================================================================
    // ====== NEW: General Settings subpage state (UI only, no API wired up yet) ==========
    // Wire these up to your own endpoints whenever you're ready — the toggle handlers
    // and file handler below are isolated so you can drop axios calls in without
    // touching anything above this line.
    // ====================================================================================
    const [generalSettings, setGeneralSettings] = useState({
        enable_birthday_emails: false,
        enable_resume_reminder_email: false,
        birthday_email_limit: 0,
        resume_reminder_email_limit: 0,
    });
    const [savingGeneral, setSavingGeneral] = useState(false);
    const [loadingGeneral, setLoadingGeneral] = useState(true);
    const [userManualFile, setUserManualFile] = useState(null); // { name, size, file } - newly picked, not yet saved
    const [existingManualName, setExistingManualName] = useState(""); // e.g. "Employee-Handbook-v2.pdf" - loaded from backend
    const [existingManualUrl, setExistingManualUrl] = useState("");   // link/download URL returned by the backend
    const [showManualUploader, setShowManualUploader] = useState(false); // toggled by "Update" button once a manual already exists
    const [dragActive, setDragActive] = useState(false);

    // Loads saved toggle values + the current user manual whenever the Settings page is visited.
    // Adjust the endpoint name/response fields to match your backend - this follows the same
    // pattern as getRoleData/getModuleData/getPermissionData above.
    const getGeneralSettingsData = async () => {
        try {
            setLoadingGeneral(true);
            let response = await axios.get(`${basePath}/getSystemSetting`, {
                headers: apiHeaderJSON,
            });
            const data = response?.data?.data;
            console.log(`response?.data ======>`, response?.data);
            if (data) {
                setGeneralSettings({
                    enable_birthday_emails: !!data?.enable_birthday_emails,
                    enable_resume_reminder_email: !!data?.enable_resume_reminder_email,
                    birthday_email_limit: data?.birthday_email_limit || 0,
                    resume_reminder_email_limit: data?.resume_reminder_email_limit || 0,
                });
                setExistingManualName(data?.manual_name || "");
                setExistingManualUrl(data?.manual_url || "");
            }
            setLoadingGeneral(false);
        } catch (error) {
            console.log(error);
            setLoadingGeneral(false);
        }
    }

    useEffect(() => {
        getGeneralSettingsData();
    }, []);

    const toggleGeneralSetting = (key) => {
        setGeneralSettings((prev) => ({ ...prev, [key]: !prev[key] }));
    }

    const handleManualFileChange = (fileList) => {
        const file = fileList?.[0];
        if (!file) return;
        // basic guard: only allow common pdf formats for a "user manual"
        const allowedTypes = ["application/pdf"];
        if (!allowedTypes.includes(file.type)) {
            toast.error("Please upload a PDF document");
            return;
        }
        setUserManualFile({ name: file.name, size: file.size, file });
    }

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        handleManualFileChange(e.dataTransfer.files);
    }

    const removeManualFile = () => setUserManualFile(null);

    // Opens the currently-saved manual (from the backend) in a new tab
    const viewExistingManual = () => {
        if (existingManualUrl) {
            window.open(existingManualUrl, "_blank", "noopener,noreferrer");
        } else {
            toast.error("Manual URL not available");
        }
    }

    // Opens a locally-picked (not yet saved) file in a new tab so the admin can preview before saving
    const viewLocalManual = () => {
        if (userManualFile?.file) {
            const tempUrl = URL.createObjectURL(userManualFile.file);
            window.open(tempUrl, "_blank", "noopener,noreferrer");
            // revoke a little later so the new tab has time to load it
            setTimeout(() => URL.revokeObjectURL(tempUrl), 60000);
        }
    }

    const cancelManualUpdate = () => {
        setUserManualFile(null);
        setShowManualUploader(false);
    }

    const saveGeneralSettings = () => {
        const formData = new FormData();
        formData.append("enable_birthday_emails", generalSettings.enable_birthday_emails);
        formData.append("enable_resume_reminder_email", generalSettings.enable_resume_reminder_email);
        formData.append("birthday_email_limit", generalSettings.birthday_email_limit);
        formData.append("resume_reminder_email_limit", generalSettings.resume_reminder_email_limit);
        // Only attach the manual if the admin actually picked a new/replacement file this visit
        if (userManualFile) {
            formData.append("user_manual", userManualFile.file);
        }

        const options = {
            url: `${basePath}/udpateSettings`,
            method: "POST",
            headers: {
                ...apiHeaderJSON,
                "Content-Type": "multipart/form-data",
            },
            data: formData,
        }

        setSavingGeneral(true);
        axios(options)
            .then((response) => {
                if (response?.status === 200) {
                    // Prefer whatever the backend confirms was saved; fall back to the local file name
                    setExistingManualName(response?.data?.manual_name || userManualFile?.name || existingManualName);
                    setExistingManualUrl(response?.data?.manual_url || existingManualUrl);
                    setUserManualFile(null);
                    setShowManualUploader(false);
                    setSavingGeneral(false);
                    getGeneralSettingsData();
                    toast.success("General Settings Saved Successfully");
                } else {
                    setSavingGeneral(false);
                    toast.error("Unable to Save General Settings");
                }
            })
            .catch((error) => {
                console.log(error);
                setSavingGeneral(false);
                toast.error("Unable to Save General Settings");
            });
    }

    const formatFileSize = (bytes) => {
        if (!bytes && bytes !== 0) return "";
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    }

    return (
        <section onClick={() => { setAccessModal(false); setIsAction(false); }} className='lightBabyGreen relative w-full mb-10'>
            <div className=' fixed bottom-3 right-4'>
                <div onClick={getPermissionData} className='cursor-pointer bg-red-600 px-2.5 py-2 rounded-full hoverRed'>
                    <FontAwesomeIcon icon={faRotateRight} size={"lg"} style={{ color: "#ffffff", }} />
                </div>
            </div>
            <div className='welcomeBarHeight babyGreen smoothTransition textDarkPurple px-10 rounded-3xl  flex items-center justify-between navAnimation '>
                <div className=' text-left'>
                    <h1 className=' text-5xl font-bold'>Settings</h1>
                    <p className=' text-gray-500 font-semibold'>Ready to start your day</p>
                </div>
                <img className=' w-44' src="/img/master.png" alt="" />
            </div>

            {/* ====== NEW: Tab switcher replaces the old static buttons ====== */}
            <div className="flex items-center gap-5 w-full">
                <div
                    onClick={(e) => { e.stopPropagation(); setActiveTab('access'); }}
                    className={`w-fit my-2 cursor-pointer rounded-full py-3 px-4 flex items-center gap-2 font-bold grayBlurShadow navAnimation
                        ${activeTab === 'access' ? 'darkPurple text-white' : 'bg-white text-gray-500 hoverGreen'}`}
                >
                    <FontAwesomeIcon icon={faShieldHalved} className="text-lg" />
                    <span>Access Control</span>
                </div>

                <div
                    onClick={(e) => { e.stopPropagation(); setActiveTab('general'); }}
                    className={`w-fit my-2 cursor-pointer rounded-full py-3 px-4 flex items-center gap-2 font-bold grayBlurShadow navAnimation
                        ${activeTab === 'general' ? 'darkPurple text-white' : 'bg-white text-gray-500 hoverGreen'}`}
                >
                    <FontAwesomeIcon icon={faGear} className="text-lg" />
                    <span>Genral Settings</span>
                </div>

                {/* Create Access only makes sense on the Access Control tab */}
                {activeTab === 'access' &&
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            setRoleId(false);
                            setModuleId(false);
                            setAccessModal(true);
                        }}
                        className="darkPurple w-fit my-2 cursor-pointer rounded-full py-2 px-3 text-white flex items-center gap-2 font-bold grayBlurShadow hoverGreen navAnimation ml-auto"
                    >
                        <img className="w-8" src="/img/addBtn.png" alt="" />
                        <button>Create Access</button>
                    </div>
                }
            </div>

            {accessModal ?
                <div onClick={() => { setRoleId(allRoles[0]?.role_id); setAccessModal(false) }} className=' w-full h-screen fixed left-0 top-0 flex items-center justify-center blurBack z-20'>
                    <div onClick={(e) => { e.stopPropagation(); }} className=' p-5 bg-white rounded-xl'>
                        <table>
                            <thead>
                                <tr className=' bg-gray-200'>
                                    <th>Role</th>
                                    <th>Module</th>
                                    <th>list</th>
                                    <th>view</th>
                                    <th>add</th>
                                    <th>edit</th>
                                    <th>delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select onChange={(e) => { setRoleId(parseInt(e.target.value)) }} >
                                            <option value="" disabled selected>Select Role</option>
                                            {allRoles?.map((val) => {
                                                return <option value={val?.id}>{val?.role_name}</option>
                                            })}
                                        </select>
                                    </td>
                                    <td>
                                        <select onChange={(e) => { setModuleId(parseInt(e.target.value)) }}>
                                            <option value="" disabled selected>Select Module</option>
                                            {allModules?.map((val) => {
                                                return <option value={val?.id}>{val?.module_name}</option>
                                            })}
                                        </select>
                                    </td>
                                    <td>
                                        <Switch onChange={() => { setAccessData({ ...accessData, list_access: !accessData?.list_access, }) }} checked={accessData?.list_access} />
                                    </td>
                                    <td>
                                        <Switch onChange={() => { setAccessData({ ...accessData, view_access: !accessData?.view_access }) }} checked={accessData?.view_access} />
                                    </td>
                                    <td>
                                        <Switch onChange={() => { setAccessData({ ...accessData, add_access: !accessData?.add_access }) }} checked={accessData?.add_access} />
                                    </td>
                                    <td>
                                        <Switch onChange={() => { setAccessData({ ...accessData, edit_access: !accessData?.edit_access }) }} checked={accessData?.edit_access} />
                                    </td>
                                    <td>
                                        <Switch onChange={() => { setAccessData({ ...accessData, delete_access: !accessData?.delete_access }) }} checked={accessData?.delete_access} />
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                        <div className=' mt-2'>
                            <button onClick={() => { submit(); }} className=' bg-green-200 text-green-600 rounded-xl px-3 py-1 font-semibold hoverGreen'>Save</button>
                        </div>
                    </div>
                </div> : null}

            {/* ====== EXISTING Access Control table — untouched, just gated behind the tab ====== */}
            {activeTab === 'access' &&
                <section className=' bg-white grayBlurShadow p-7 rounded-3xl mb-8'>
                    <div className=' flex items-center p-2 mb-2 grayBlurShadow border-2 rounded-lg w-fit'>
                        <h1 className=' text-left font-semibold pl-1 mr-2'>Role</h1>
                        <select value={roleId} className=' outline-none text-xl font-semibold text-blue-800' onChange={(e) => { setEdit_access(false); setRoleId(parseInt(e.target.value)) }} >
                            {allRoles?.map((val) => {
                                return (
                                    <option className=' ' key={val?.id} value={parseInt(val.id)}>{val?.role_name}</option>
                                )
                            })}
                        </select>
                    </div>
                    {!loading ?
                        <div className=' overflow-auto tableBody tableBox'>
                            {filterAccess.length > 0 ?
                                <table className=' navAnimation rounded-2xl baseWidth'>
                                    <thead className=' text-lg tableHead z-10 headingRow'>
                                        <tr className=' bg-gray-200'>
                                            <th>Module</th>
                                            <th>List</th>
                                            <th>view</th>
                                            <th>add</th>
                                            <th>edit</th>
                                            <th>delete</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className='tableBody '>
                                        {
                                            filterAccess?.map((val, idx) => {
                                                return (
                                                    <>
                                                        {
                                                            // edit access control
                                                            edit_access === val.id ?
                                                                <tr key={val?.id} id={val?.id} className=' backWhite font-semibold text-sm'>
                                                                    <td >{val?.Module.module_name}</td>
                                                                    <td ><Switch onChange={() => { setAccessData({ ...accessData, list_access: accessData?.list_access ? false : true }) }} checked={accessData?.list_access} disabled={false} /></td>
                                                                    <td ><Switch onChange={() => { setAccessData({ ...accessData, view_access: accessData?.view_access ? false : true }) }} checked={accessData?.view_access} disabled={false} /></td>
                                                                    <td ><Switch onChange={() => { setAccessData({ ...accessData, add_access: accessData?.add_access ? false : true }) }} checked={accessData?.add_access} disabled={false} /></td>
                                                                    <td ><Switch onChange={() => { setAccessData({ ...accessData, edit_access: accessData?.edit_access ? false : true }) }} checked={accessData?.edit_access} disabled={false} /></td>
                                                                    <td><Switch onChange={() => { setAccessData({ ...accessData, delete_access: accessData?.delete_access ? false : true }) }} checked={accessData?.delete_access} disabled={false} /></td>
                                                                    <td className=' flex justify-center items-center'>
                                                                        <div className=' relative w-fit'>
                                                                            <button onClick={() => { handleSubmitUpdate() }} className=' bg-green-200 text-green-600 rounded-xl px-3 py-1 font-semibold'>{!loadingUpdate?"Save":"Saving..."}</button>
                                                                        </div>
                                                                    </td>
                                                                </tr> :
                                                                // view access control
                                                                <tr key={val?.id} id={val?.id} className=' backWhite font-semibold text-sm'>
                                                                    <td >{val?.Module.module_name}</td>
                                                                    <td ><Switch checked={val?.list_access} disabled={true} /></td>
                                                                    <td ><Switch checked={val?.view_access} disabled={true} /></td>
                                                                    <td ><Switch checked={val?.add_access} disabled={true} /></td>
                                                                    <td ><Switch checked={val?.edit_access} disabled={true} /></td>
                                                                    <td><Switch checked={val?.delete_access} disabled={true} /></td>
                                                                    <td className=' flex justify-center items-center'>
                                                                        <div className=' relative w-fit'>
                                                                            {edit_access === val?.id ?
                                                                                <button onClick={() => setEdit_access(false)} className=' bg-green-200 text-green-600 rounded-xl px-3 py-1 font-semibold'>Save</button> :
                                                                                <div onClick={(e) => { e.stopPropagation(); setIsAction(val?.id); }} className=' flex flex-row gap-1 cursor-pointer w-fit p-2 rounded-lg hoverGreen'>
                                                                                    <div className=' w-2 h-2 darkPurple rounded-full '></div>
                                                                                    <div className=' w-2 h-2 darkPurple rounded-full '></div>
                                                                                    <div className=' w-2 h-2 darkPurple rounded-full '></div>
                                                                                </div>}

                                                                            {isAction === val?.id ?
                                                                                < div className={`absolute ${allModules?.length - 2 <= idx && allModules?.length > 2 ? "bottom-5 z-10 right-2" : "right-2 z-10 top-5"} w-40 h-fit p-3 rounded-xl border-2 bg-white grayBlurShadow`} >
                                                                                    <div className='flex flex-col'>
                                                                                        <button onClick={(e) => {  handleEdit(e, idx, val?.id, val?.role_id, val?.module_id) }} className=' text-yellow-600 bg-yellow-200 m-2 px-4 py-1 rounded-lg hoverYellow' >Edit</button>
                                                                                        <button onClick={(e) => { handleDelete(e, val?.id) }} className=' text-red-700 bg-red-200 mx-2 px-2 py-1 rounded-lg hoverRed'>Delete</button>
                                                                                    </div>
                                                                                </div> : null
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                        }
                                                    </>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table> :
                                <div className=' flex flex-col items-center'>
                                    <img className=' w-1/4' src="/img/addReports.png" alt="" />
                                    <h1 className=' text-xl font-bold'>Oops!! "<span className=' text-blue-950'>Access Control Data Not Found!!!</span>"</h1>
                                </div>}
                        </div> : <div className=' loaderBox mb-5 bg-white mt-5 rounded-3xl '>
                            <img className=' m-auto w-1/4' src="/img/loader2.gif" alt="loading..." />
                        </div>
                    }

                </section>
            }

            {/* ==================================================================================== */}
            {/* ====== NEW: General Settings subpage ================================================ */}
            {/* ==================================================================================== */}
            {activeTab === 'general' &&
                <section onClick={(e) => e.stopPropagation()} className='bg-white grayBlurShadow p-7 rounded-3xl mb-8'>
                    <h2 className='text-2xl font-bold textDarkPurple mb-1'>General Settings</h2>
                    <p className='text-gray-500 font-medium mb-6'>Basic system preferences and documentation</p>

                    {loadingGeneral ?
                        <div className=' loaderBox mb-5 bg-white mt-5 rounded-3xl '>
                            <img className=' m-auto w-1/4' src="/img/loader2.gif" alt="loading..." />
                        </div>
                        : <>
                    {/* Yes/No toggle questions */}
                    <div className='flex flex-col divide-y divide-gray-100 border-2 rounded-2xl mb-8 text-left'>

                        {/* Birthday Wishes Toggle */}
                        <div className='flex items-center justify-between px-5 py-4'>
                            <div>
                                <p className='font-semibold'>Daily Birthday Wishes Email</p>
                                <p className='text-sm text-gray-400'>
                                    Automatically send birthday wishes to candidates via email on behalf of TalentCo HR Services.
                                </p>
                            </div>

                            <Switch
                                onChange={() => toggleGeneralSetting("enable_birthday_emails")}
                                checked={generalSettings.enable_birthday_emails}
                                onColor='#86efac'
                                onHandleColor='#16a34a'
                            />
                        </div>

                        {/* Resume Reminder Toggle */}
                        <div className='flex items-center justify-between px-5 py-4'>
                            <div>
                                <p className='font-semibold'>Daily Resume Update Reminder Email</p>
                                <p className='text-sm text-gray-400'>
                                    Automatically send reminder emails to candidates in the CV Management Pool to update their latest resume.
                                </p>
                            </div>

                            <Switch
                                onChange={() => toggleGeneralSetting("enable_resume_reminder_email")}
                                checked={generalSettings.enable_resume_reminder_email}
                                onColor='#86efac'
                                onHandleColor='#16a34a'
                            />
                        </div>

                        {/* Birthday Email Limit Input */}
                        <div className='flex items-center justify-between px-5 py-4'>
                            <div className='flex-1 pr-4'>
                                <p className='font-semibold'>Daily Birthday Email Limit</p>
                                <p className='text-sm text-gray-400'>
                                    Set the maximum number of birthday emails that can be sent per day.
                                </p>
                            </div>

                            <input
                                type='number'
                                min='0'
                                value={generalSettings.birthday_email_limit}
                                onChange={(e) =>
                                    setGeneralSettings({
                                        ...generalSettings,
                                        birthday_email_limit: e.target.value,
                                    })
                                }
                                className='w-28 rounded-lg border border-gray-300 px-3 py-2 text-center outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100'
                                placeholder='-'
                            />
                        </div>

                        {/* Resume Reminder Email Limit Input */}
                        <div className='flex items-center justify-between px-5 py-4'>
                            <div className='flex-1 pr-4'>
                                <p className='font-semibold'>Daily Resume Reminder Email Limit</p>
                                <p className='text-sm text-gray-400'>
                                    Set the maximum number of resume reminder emails that can be sent per day.
                                </p>
                            </div>

                            <input
                                type='number'
                                min='0'
                                value={generalSettings.resume_reminder_email_limit}
                                onChange={(e) =>
                                    setGeneralSettings({
                                        ...generalSettings,
                                        resume_reminder_email_limit: e.target.value,
                                    })
                                }
                                className='w-28 rounded-lg border border-gray-300 px-3 py-2 text-center outline-none focus:border-green-500 focus:ring-2 focus:ring-green-100'
                                placeholder='-'
                            />
                        </div>

                    </div>

                    {/* User manual upload */}
                    <div className='mb-2'>
                        <h3 className='font-bold text-lg mb-1'>User Manual</h3>
                        <p className='text-sm text-gray-400 mb-3'>Upload the document employees see when they need help using the system</p>

                        {/* Case 1: a manual already exists and the admin isn't currently replacing it
                            -> show it with View + Update actions, no uploader visible */}
                        {existingManualName && !showManualUploader &&
                            <div className='flex items-center justify-between border-2 rounded-xl px-4 py-3 bg-gray-50'>
                                <div className='flex items-center gap-3'>
                                    <FontAwesomeIcon icon={faFilePdf} className='text-red-500 text-xl' />
                                    <div>
                                        <p className='font-semibold text-sm'>{existingManualName}</p>
                                        <p className='text-xs text-gray-400'>Currently active</p>
                                    </div>
                                </div>
                                <div className='flex items-center gap-2'>
                                    <button
                                        onClick={viewExistingManual}
                                        className='text-blue-700 bg-blue-100 rounded-lg px-3 py-1 font-semibold text-sm hover:bg-blue-200 navAnimation'
                                    >
                                        View
                                    </button>
                                    <button
                                        onClick={() => setShowManualUploader(true)}
                                        className='text-yellow-700 bg-yellow-100 rounded-lg px-3 py-1 font-semibold text-sm hover:bg-yellow-200 navAnimation'
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                        }

                        {/* Case 2: no manual uploaded yet, OR admin clicked "Update" to replace the existing one
                            -> show the dropzone (with a Cancel option when replacing) */}
                        {(!existingManualName || showManualUploader) &&
                            <>
                                {existingManualName && showManualUploader &&
                                    <div className='flex justify-end mb-2'>
                                        <button onClick={cancelManualUpdate} className='text-sm text-gray-400 hover:text-gray-600 font-semibold'>
                                            Cancel
                                        </button>
                                    </div>
                                }
                                {!userManualFile &&
                                    <label
                                        htmlFor='userManualUpload'
                                        onDragOver={(e) => { e.preventDefault(); setDragActive(true); }}
                                        onDragLeave={() => setDragActive(false)}
                                        onDrop={handleDrop}
                                        className={`flex flex-col items-center justify-center gap-2 border-2 border-dashed rounded-2xl py-8 px-4 cursor-pointer navAnimation
                                            ${dragActive ? 'border-green-400 bg-green-50' : 'border-gray-300 hoverGreen'}`}
                                    >
                                        <FontAwesomeIcon icon={faFileArrowUp} className='text-3xl text-gray-400' />
                                        <p className='font-semibold text-gray-600'>Click to upload or drag and drop</p>
                                        <p className='text-xs text-gray-400'>PDF or Word document, up to 10MB</p>
                                        <input
                                            id='userManualUpload'
                                            type='file'
                                            className='hidden'
                                            accept='.pdf,.doc,.docx'
                                            onChange={(e) => handleManualFileChange(e.target.files)}
                                        />
                                    </label>
                                }

                                {userManualFile &&
                                    <div className='flex items-center justify-between border-2 rounded-xl px-4 py-3'>
                                        <div className='flex items-center gap-3'>
                                            <FontAwesomeIcon icon={faCircleCheck} className='text-green-500 text-xl' />
                                            <div>
                                                <p className='font-semibold text-sm'>{userManualFile.name}</p>
                                                <p className='text-xs text-gray-400'>{formatFileSize(userManualFile.size)} &middot; not yet saved</p>
                                            </div>
                                        </div>
                                        <div className='flex items-center gap-2'>
                                            <button
                                                onClick={viewLocalManual}
                                                className='text-blue-700 bg-blue-100 rounded-lg px-3 py-1 font-semibold text-sm hover:bg-blue-200 navAnimation'
                                            >
                                                View
                                            </button>
                                            <button onClick={removeManualFile} className='text-red-500 hover:text-red-700 px-2'>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </div>
                                    </div>
                                }
                            </>
                        }
                    </div>

                    <div className='mt-6'>
                        <button
                            onClick={saveGeneralSettings}
                            disabled={savingGeneral}
                            className='darkPurple text-white rounded-xl px-6 py-2 font-semibold hoverGreen navAnimation'
                        >
                            {!savingGeneral ? "Save Settings" : "Saving..."}
                        </button>
                    </div>
                    </>}
                </section>
            }
        </section>
    );
}

export default AccessControl;